import { Base, withBreakpointObserver } from '@studiometa/js-toolkit';
import Swiper from 'swiper';
import { Autoplay, Pagination } from 'swiper/modules';

/**
 * Hero Slider component
 */
export default class HeroSlider extends withBreakpointObserver(Base) {
  static config = {
    name: 'HeroSlider',
    refs: ['slider', 'pagination'],
  };

  /** @returns {void} */
  mounted() {
    this.slider = new Swiper(this.$refs.slider, {
      modules: [Autoplay, Pagination],
      slidesPerView: 1,
      grabCursor: true,
      loop: true,
      autoplay: {
        delay: 8000,
        disableOnInteraction: false,
        pauseOnMouseEnter: false,
      },
      pagination: {
        clickable: true,
        el: this.$refs.pagination,
      },
    });
  }

  /** @returns {void} */
  destroyed() {
    if (this.slider) {
      this.slider.destroy(true, true);
    }
  }
}
